export default "__VITE_ASSET__DsSMqH88__"